import React from 'react';
import {
  TICKET_STATUS_LABELS,
  TICKET_PRIORITY_LABELS,
  TICKET_CATEGORY_LABELS,
  type TicketStatus,
  type TicketPriority,
  type TicketCategory,
} from '../types/ticket';

const STATUS_STYLE: Record<TicketStatus, string> = {
  open: 'bg-blue-500/15 text-blue-300 border-blue-500/40',
  in_progress: 'bg-yellow-500/15 text-yellow-300 border-yellow-500/40',
  resolved: 'bg-[#1f9e3f22] text-[#6ee06f] border-[#1f9e3f55]',
  closed: 'bg-slate-500/15 text-slate-300 border-slate-500/40',
};

const PRIORITY_STYLE: Record<TicketPriority, string> = {
  low: 'bg-slate-500/15 text-slate-300 border-slate-500/40',
  medium: 'bg-yellow-500/15 text-yellow-300 border-yellow-500/40',
  high: 'bg-red-500/15 text-red-300 border-red-500/40',
};

const base =
  'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border';

export const StatusBadge: React.FC<{ status: TicketStatus }> = ({ status }) => (
  <span className={`${base} ${STATUS_STYLE[status]}`}>
    {TICKET_STATUS_LABELS[status]}
  </span>
);

export const PriorityBadge: React.FC<{ priority: TicketPriority }> = ({
  priority,
}) => (
  <span className={`${base} ${PRIORITY_STYLE[priority]}`}>
    {TICKET_PRIORITY_LABELS[priority]}
  </span>
);

export const CategoryBadge: React.FC<{ category: TicketCategory }> = ({
  category,
}) => (
  <span className={`${base} bg-white/5 text-[#94a3b8] border-white/10`}>
    {TICKET_CATEGORY_LABELS[category]}
  </span>
);
